import { Avatar } from "@mui/material";

type AvatarProps = {
  firstName?: string;
  lastName?: string;
  photoUrl?: string;
};

export const UserAvatar: React.FC<AvatarProps> = ({
  photoUrl,
  firstName,
  lastName,
}) => {
  const initials =
    firstName && lastName && firstName.charAt(0) + lastName.charAt(0);

  return (
    <Avatar
      src={photoUrl}
      sx={{ bgcolor: "primary.main", width: "38px", height: "38px" }}
      variant="rounded"
    >
      {initials}
    </Avatar>
  );
};
